/* eslint-disable import/order */
/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import { mdiClipboardArrowLeftOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useState } from 'react';
import AlertDialog from '../ConfirmationDialog';
import api from '../../service/api';
import { toast } from 'react-toastify';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';

const LeadsOriginTable = ({ brokers = [] }) => {
  const [isOpen, setIsOpen] = useState(null);

  const handleOpenDetails = (id) => {
    setIsOpen(id == isOpen ? null : id);
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Corretor</TableCell>
            <TableCell align="right">Quantidade</TableCell>
            <TableCell align="right" style={{ maxWidth: '50px', width: '50px' }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {brokers?.map((broker, index) => (
            <>
              <TableRow key={broker?.id}>
                <TableCell>{broker?.name}</TableCell>
                <TableCell align="right">{broker?.leads_count}</TableCell>
                <TableCell align="right">
                  <IconButton size="small" onClick={() => handleOpenDetails(broker?.id)}>
                    {isOpen == broker?.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                  </IconButton>
                </TableCell>
              </TableRow>

              {isOpen == broker?.id && (
                <TableRow key={`second-table-${broker?.id}`}>
                  <TableCell colSpan={3}>
                    <SecondTable leadsByChannel={broker?.leads_by_channel} />
                  </TableCell>
                </TableRow>
              )}
            </>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const SecondTable = ({ leadsByChannel = [] }) => {
  return (
    <TableContainer style={{ boxShadow: '0px 0px 24px -4px rgba(0,0,0,0.1)', borderRadius: '12px' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: 'bold' }}>Canal</TableCell>
            <TableCell align="right" style={{ fontWeight: 'bold' }}>
              Quantidade
            </TableCell>
            <TableCell align="right" style={{ maxWidth: '50px', width: '50px' }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {leadsByChannel?.map((origin) => (
            <>
              {![1]?.includes(origin?.id) && (
                <TableRow key={`second-table-channel-${origin?.id}`}>
                  <TableCell>{origin?.name}</TableCell>
                  <TableCell align="right">{origin?.qtd}</TableCell>
                  <TableCell align="right" />
                </TableRow>
              )}

              {origin?.by_insurance?.map((byInsurance) => (
                <TableRow key={`second-table-channel-insurance-${byInsurance?.insurance_id}`}>
                  <TableCell>
                    {origin?.name} - {byInsurance?.name}
                  </TableCell>
                  <TableCell align="right">{byInsurance?.qtd}</TableCell>
                  <TableCell align="right" />
                </TableRow>
              ))}
            </>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default LeadsOriginTable;
